
<script lang="ts" setup>
import { computed } from 'vue'

import DarwinAvatar from '@/uiKit/Avatar/DarwinAvatar.vue'

import type { ApiKeyPayload } from './types'
import { useTeamStore } from '@/pinia/useTeamStore'

/**
 * Used to render an avatar of the team the API key is associated with.
 *
 * Uses standard avatar icon.
 */
const props = defineProps<{ apiKey: ApiKeyPayload }>()

const team = computed(() => useTeamStore().teams.find((t) => t.id === props.apiKey.team_id))

const avatarUrl = computed(() => team.value?.image?.thumbnail_url || team.value?.image?.url || null)
</script>

<template>
  <div
    v-if="team"
    class="key-team-avatar"
  >
    <DarwinAvatar
      v-if="team"
      :id="team.id"
      class="key-team-avatar__avatar"
      :size="35"
      :name="team.name"
      :url="avatarUrl"
    />
    <span class="key-team-avatar__label">
      {{ team.name }}
    </span>
  </div>
</template>

<style lang="scss" scoped>
.key-team-avatar {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;

  &__avatar {
    cursor: pointer;
    user-select: none;
    height: 35px;
    width: 35px;
  }

  &__label {
    color: $colorContentSecondary;
    @include typographyRegularBody200;
  }
}
</style>
